import { AppData, Colors, Img, Lightning, Log, Registry, Router, Utils } from '@lightningjs/sdk'
import { AppSetup } from '../lib/app-setup'
import GridViewModel, { FocusInfo } from '../lib/components/grid/grid-view-model'
import MultiRowGrid from '../lib/components/grid/multirow-grid'
import InfoUI from '../ui-elements/info-ui'
import { ItemNode } from "../lib/components/grid/ItemNode"
import { Logger } from '../lib/logger'
import { AppApiConfig, Channel } from '../lib/app-api-config'
import { Helper } from '../lib/helper'
import { KeyCodes } from '../lib/key-codes'
import { IDialogueInfo } from '../lib/interfaces'
import { DIALOG_BUTTON_ACTION } from '../lib/enum'


export interface MainGridTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Background: object
    focusRow: number
    RowListWrapper: object
    MultiRowGrid: object
    Logo: object
    activeL1Load: Function
}

export interface MainGridTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true
}

export default class MainGrid
    extends Lightning.Component<MainGridTemplateSpec, MainGridTypeConfig>
    implements Lightning.Component<MainGridTemplateSpec>
{
    channel!: Channel
    Background = this.getByRef('Background')!
    RowListWrapper = this.getByRef('RowListWrapper')!
    MultiRowGrid = this.getByRef('MultiRowGrid')!
    Logo = this.getByRef('Logo')!

    gridViewModel!: GridViewModel
    focusRow = 0

    loadingTimeoutId = null;
    isMenuFocused = false;
    
    longPressTimestamp = 0;
    isKeyDown = false;
    notFoundMsgNoSeconds = 5000; // 5 seconds

    static override _template(): Lightning.Component.Template<MainGridTemplateSpec> {
        return {
            ...super._template(),
            w: 1920,
            h: 1080,
            rect: true,
            color: 0xff222222,
            Background: {
                rect: true,
                w: 1920,
                h: 1080,
                color: 0xff222222,
            },
            ItemInfo: {
                w: 1920,
                h: 1080,
                type: InfoUI,
            },
            Logo: {
                x: 172,
                y: 66,
            },
            RowListWrapper: {
                x: 12,
                y: 515,
                w: 1920,
                h: 565,
                collision: true,
                boundsMargin: [440, 500, 880, 880],
                clipping: true,
                zIndex: 5,
                MultiRowGrid: undefined
            },
            NodeNotFoundMsgBox: {
                w: (w: any) => w,
                h: (h: any) => h,
                color: 0xee000000,
                rect: true,
                zIndex: 100,
                flex: { alignItems: 'center', justifyContent: 'center' },
                MsgBox: {
                  text: {
                    text: "Sorry, the content you're looking for is currently not available, please try again later!",
                    wordWrapWidth: 600,
                    fontFace: Helper.getFontFamily('Black'),
                    letterSpacing: 0.82,
                    lineHeight: 47,
                    fontSize: 36,
                  }
                },
                visible: false
              }
        }
    }

    override _init() {
        //this.widgets.loadingscreen.showL1LoadingScreen(false)
    }

    override _active(): void {
        //this.widgets.loadingscreen.showL1LoadingScreen(true)
    }

    $gridFocusChange() {
        Log.info('$gridFocusChange')
        //this._gridFocusedHandler(null)
    }

    override _getFocused():
        | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
        | null
        | undefined {
        return this.tag('MultiRowGrid')!
    }

    override _focus(): void {
        Log.info('MainGridTemplateSpec: _focus fired')

        //this.widgets.Loading.showL1LoadingScreen(true)
    }

    reloadGrid() {
        this.tag('MultiRowGrid').reloadGrid()
    }

    resetFocus(focusObj: FocusInfo) {
        this.tag('MultiRowGrid').resetFocus(focusObj)
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
       // console.log('_handleKey : ', e)
        Log.info('MainGridTemplateSpec: _handleKey ', e)
        const { platform } = AppData as AppSetup
        //XFIN-162 - Comcast - Implement alternative way to open star menu for PlatCo
        //Open option menu when 0 is pressed.
        if(e.keyCode == KeyCodes.KEY_LONG_OK) {
            this.$handleLongEnter()
            return true
        }
        if(platform?.isOptionsKey(e)) {
            platform?.textToSpeach('Opening Options Menu')
            Router.focusWidget('OptionsMenu')
            return true
        }
        if(e.keyCode == KeyCodes.KEY_EXIT) {
            const { appState } = AppData as AppSetup
            const app = appState?.getApp()
            app?.handleAppExit()
            return true
        }
        // if(Helper.getAppType() && 
        //     (Helper.getAppType().indexOf('platco') > -1 ||
        //     Helper.getAppType().indexOf('vizio') > -1 ||
        //     Helper.getAppType().indexOf('lg') > -1)
        // ) {
        //     if (e.code == 'Digit0') {
        //         platform?.textToSpeach('Opening Options Menu')
        //         Router.focusWidget('OptionsMenu')
        //         return true
        //     }
        // } else {
        //     if (e.code == 'KeyI') {
        //         platform?.textToSpeach('Opening Options Menu')
        //         Router.focusWidget('OptionsMenu')
        //         return true
        //     }
        // }
        return false
    }

    _gridLoadedHandler(event: any) {
        Log.info('MainGridTemplateSpec: gridViewModel: _gridLoadedHanlder: ', event)
        Log.info('MainGridTemplateSpec: gridViewModel: ', this.gridViewModel)
        Logger.processUserAction('gridContentLoaded', '')
        if(!this.gridViewModel._isRowsLoaded()) {
            this.isRowsLoaded = false
            this.tag('NodeNotFoundMsgBox').visible = true
        } else {
            this.isRowsLoaded = true
            this.patch({
                RowListWrapper: {
                    MultiRowGrid: {
                        x: 172,
                        y: 0,
                        w: (w: any) => w,
                        h: (h: any) => h,
                        grid:this.gridViewModel,
                        collision: true,
                        //item: this.gridViewModel,
                        type: MultiRowGrid,
                        items: [],
                        itemSpacing: 10,
                    }
                }
            })
        }
        this.loadingTimeoutId = Registry.setTimeout(() => {
            //this.widgets.loading
            this.widgets.loadingscreen.showL1LoadingScreen(false)
        }, 1000)
    }

    _gridFocusedHandler(event: any) {
        const { platform, appState } = AppData as AppSetup;
        const vodInfo: ItemNode = this.gridViewModel.getFocusedItem();
        Log.info('MainGridTemplateSpec:_gridFocusedHandler: ', this.gridViewModel.getFocusInfo(), vodInfo)
        this.patch({
            ItemInfo: {
                item: vodInfo,
            }
        })
        // console.log('vodInfo', vodInfo)
        platform?.textToSpeach(`${vodInfo.title}  ${vodInfo.description}`)

        /* Fix for XFIN-1190 */
        // Show sorry popup if deeplink not found
        if (appState.showDeeplinkSorryMsgOnGrid) {
            this.showHideMessage(true)
            appState.showDeeplinkSorryMsgOnGrid = false
            Registry.setTimeout(() => {
                this.showHideMessage(false)
            }, this.notFoundMsgNoSeconds)
        }
        /* Fix for XFIN-1190 */
    }

    _gridSelectedHandler(event: any) {
        const vodInfo: ItemNode = this.gridViewModel.getFocusedItem();
        const { appState, platform } = AppData as AppSetup
        const app = appState?.getApp()
        const { focusRow, foucsItem } = this.gridViewModel.getFocusInfo()
        Log.info('MainGridTemplateSpec:_gridSelectedHandler: ', this.gridViewModel.getFocusInfo(), vodInfo)
        if (app?.blockingManager.checkAndShowAgeRatingPopup(vodInfo, this._handleSimpleAgeRestrictionCallback.bind(this))) {
            return;
        }
        if (app?.blockingManager.isItemBlocked(vodInfo)) {
            this.widgets.notification.showMessage('')
            return;
        }
        this.checkBookmarkOrVideoResume(vodInfo)
        platform?.textToSpeach(`Playing ${vodInfo.title}`)
    }

    _handleSimpleAgeRestrictionCallback(actionBtn:any, dialogInfo:IDialogueInfo) {
        //console.log('_handleSimpleAgeRestrictionCallback: ', actionBtn.action)
        const { appState, appConfig } = AppData as AppSetup
        const app = appState?.getApp()
        if(actionBtn.action == DIALOG_BUTTON_ACTION.YES) {
            this.checkBookmarkOrVideoResume(dialogInfo.callbackData)
        } else if(actionBtn.action == DIALOG_BUTTON_ACTION.NO) {
            // app?.navigation.reset()
            // appConfig.aContent = false
            // Router.navigate('main-grid-screen/' + app?.l1CategoryToLoad + '_true', false)
            app?.reloadAppOnParentalControlChange(false)
        } else if (actionBtn.action == DIALOG_BUTTON_ACTION.CLOSE) {
            //reset the isAgePopupShown to false as the user have not select any options. 
            appConfig.isAgePopupShown = false;
        }
    }

    _handleBookmarking(vodInfo) {
        this.widgets.bookmark.$setbdata(vodInfo)
        Router.focusWidget('Bookmark')
    }

    _handleVideoResume(vodInfo) {
        const { appConfig, appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig()
        let resumeTime = null
        if (appConfig?.useLocalStorage == true) {
            resumeTime = localStorage.getItem(vodInfo.node_id)!;
        } else {
            resumeTime = Helper.getCookie(vodInfo.node_id);
        }

        if (resumeTime !== "" && resumeTime !== null && resumeTime !== 0 && resumeTime !== '0' && (appApiConfig?.appConfig?.resumeVidMinDuration && vodInfo.runtime > appApiConfig?.appConfig?.resumeVidMinDuration)) {
            this.widgets.bookmark.$setbdata(vodInfo)
            Router.focusWidget('Bookmark')
        } else {
            Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
        }
    }

    /**
     * Handler to show bookmark screen or video resume screen.
     * @param {number} vodInfo - Video info.
     * @returns - NA
     */
    checkBookmarkOrVideoResume(vodInfo, force=false) {
        if(force) {
            this.widgets.moreinfo.$setbdata(vodInfo)
            Router.focusWidget('Moreinfo')
            return;
        }
        if (vodInfo.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
            Logger.processUserAction('showClickedOnGrid', vodInfo.id);
            //Router.navigate(`mlp-grid-screen/${vodInfo.id}`, false)
            this._handleBookmarking(vodInfo)
        } else if (vodInfo.feed_type == 'video') {
            Logger.processUserAction('videoItemSelectedFromGrid', vodInfo.node_id);
            this._handleVideoResume(vodInfo)
            //Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
        } else if (vodInfo.feed_type == 'live') {
            Logger.processUserAction('videoItemSelectedFromGrid', vodInfo.node_id);
            Router.navigate('video-screen-live/' + vodInfo.node_id, false)
        }
    }


    override _onDataProvided(): void {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!
        const channel = appApiConfig.appConfig.channels[app?.l1CategoryToLoad]
        let bgImage = Utils.asset('/images/info_bg-236.png');
        if(channel && channel.bg_image) {
            bgImage = channel.bg_image
        }
        Log.info('MainGridTemplateSpec: _onDataProvided fired')
        this.gridViewModel.on('loaded', this._gridLoadedHandler, this)
        this.gridViewModel.on('focused', this._gridFocusedHandler, this)
        this.gridViewModel.on('selected', this._gridSelectedHandler, this)
        this.gridViewModel._init()



        this.patch({
            ItemInfo: {
                //background: Utils.asset('/images/info_bg-236.png'),
                background: bgImage,
            },
            Logo: {
                texture: {
                    src: app?.appApiConfig?.appBrandConfig?.header_logo,
                    resizeMode: {
                        h: 60,
                        w: 460,
                        type: 'contain',
                    },
                    type: Lightning.textures.ImageTexture
                },
            }
        })
        this.widgets.loadingscreen.showL1LoadingScreen(true)
    }

    $handleLongEnter() {
        Log.info('MainGrid:', '_handleLongPress')
        Router.focusWidget('OptionsMenu')
    }

    override _handleLeft() {
        Log.info('MainGrid:', '_handleLeft')
        this.isMenuFocused = true;
        Router.focusWidget('Menu')
        return true
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        Log.info('MainGrid:_handleBack ')
        /* Fix for XFIN-1190 */
        if (this.tag('NodeNotFoundMsgBox').visible) {
            this.showHideMessage(false)
            this._getFocused()
            return
        }
        /* Fix for XFIN-1190 */
        this.isMenuFocused = true
        Router.focusWidget('Menu')
        return true
    }

    override _handleRight() {
        Log.info('MainGrid:', '_handleRight')
        return false
    }

    override _detach() {
        this.stage.gc(false)
        if (!this.gridViewModel) return
        this.gridViewModel.off('loaded', this._gridLoadedHandler, this)
        this.gridViewModel.off('focused', this._gridFocusedHandler, this)
        this.gridViewModel.off('selected', this._gridSelectedHandler, this)
    }

    showHideMessage(visible: boolean) {
        this.patch({
            NodeNotFoundMsgBox: {
                visible: visible,
                MsgBox: {
                    text: {
                        text: "We're sorry, the title you're looking for is no longer available. But we're loading our selection for you! There's plenty more to enjoy, hope you like it."
                    }
                }
            }
        })
    }
    _handleHover(target) {
        // console.log('MainGrid Hover: ',  target)
        //this._focus()
        //this.fireAncestors('$handleHover', target)
    }

    // _handleUnhover(target) {
    //     console.log('MainGrid Unhover ', target)
    //     //this._unfocus()
    // }
}
